import { Controller, Loader, IDynamicLoader } from '@tencent/workbench';
import { Form, NumberInputFrom } from '@tencent/wb-ext-form';
import { IMultiDiffValue, INPUT_PROPS_CALLBACK_KEY } from '@framework/workbench/drawer/constants';
import { FORM_CONFIGS, SIZE_MAX } from './config';
import { IChartGlowFeature } from './chart-glow-interface';
import { ChartFormItemKey } from '@tencent/chart-drawer-components/lib/schema';

@Controller({ formItems: FORM_CONFIGS })
export class ChartGlobalGlowController {
    constructor(@Loader(IChartGlowFeature) private loader: IDynamicLoader<IChartGlowFeature>) {}

    private get feature() {
        return this.loader.instance!;
    }

    @Form(ChartFormItemKey.CHART_GLOBAL_GLOW, 'content')
    public renderPreset() {
        return this.feature.renderPreset();
    }

    @Form(ChartFormItemKey.CHART_GLOBAL_GLOW_SIZE, 'value')
    public getSize(): number | IMultiDiffValue {
        return this.feature.getShownValue(INPUT_PROPS_CALLBACK_KEY.CHART_GLOBAL_GLOW, { size: this.feature.size });
    }

    @Form(ChartFormItemKey.CHART_GLOBAL_GLOW_SIZE, 'onChange')
    public changeSize(value: number, dragEnd?: boolean, from?: NumberInputFrom): void {
        const sizeObj = this.feature.getValidValue({ size: value }, from, SIZE_MAX);
        this.feature.handleGlowChange(sizeObj, dragEnd, from);
    }

    @Form(ChartFormItemKey.CHART_GLOBAL_GLOW_OPICITY, 'value')
    public getOpacity(): number | IMultiDiffValue  {
        return this.feature.getShownValue(
            INPUT_PROPS_CALLBACK_KEY.CHART_GLOBAL_GLOW,
            { opacity: this.feature.opacity },
        );
    }

    @Form(ChartFormItemKey.CHART_GLOBAL_GLOW_OPICITY, 'onChange')
    public changeOpacity(value: number, dragEnd?: boolean, from?: NumberInputFrom): void {
        const opacityObj = this.feature.getValidValue({ opacity: value }, from);
        this.feature.glowInfo.tdColor?.updateOpacity?.(value);
        this.feature.handleGlowChange(opacityObj, dragEnd, from);
    }

    @Form(ChartFormItemKey.CHART_GLOBAL_GLOW_COLOR, 'content')
    public getColorSelectButton() {
        return this.feature.getColorSelectButton();
    }
}
